import { Icon, Typography, Checkbox, Slider } from '@scale/scaleui';
import { useAuditLayoutStore } from '../hooks/useAuditLayoutStore';
import { AuditColumnOrderingDraggable } from './AuditColumnOrderingDraggable';

export function AuditLayoutControlPanel() {
  const store = useAuditLayoutStore();

  return (
    <div className="flex flex-grow-0 rounded-md gap-2">
      <div>
        <Icon
          icon="cog"
          variant="secondary"
          onClick={() => store.setShowConfig(!store.showConfig)}
          hasBackground
          tooltip="Audit view advanced layout options"
        />
      </div>
      <div
        className="overflow-hidden transition-width duration-150 flex"
        style={{ width: store.showConfig ? 260 : 0 }}
      >
        <div className="flex flex-col flex-shrink-0 gap-4 px-1" style={{ flex: '0 0 0' }}>
          <Typography.Subtitle2>Audit Layout Options</Typography.Subtitle2>
          <div className="flex flex-col gap-2">
            <Typography.Subtitle3>Display Options</Typography.Subtitle3>
            <Checkbox
              id="showBefore"
              label="Show before steps"
              checked={store.showBefore}
              onChange={store.toggleShowBefore}
            />
            <Checkbox
              id="showAfter"
              label="Show after steps"
              checked={store.showAfter}
              onChange={store.toggleShowAfter}
            />
            <Checkbox
              id="highlightSelectionPath"
              label="Hide unselected responses"
              checked={store.hideUnselectedResponses}
              onChange={store.toggleHideUnselectedResponses}
            />
            <Checkbox
              id="showCompactMode"
              label="Expand before/after steps"
              checked={!store.compactMode}
              onChange={store.toggleCompactMode}
            />
          </div>
          <div>
            <Typography.Subtitle3>Column Width</Typography.Subtitle3>
            <Slider
              label="Column width"
              value={(store.columnWidthEx - 20) / 1.5}
              setValue={value => {
                store.setColumnWidthEx(Math.floor(value * 1.5 + 20));
              }}
            />
          </div>
          <div className="flex flex-col gap-2">
            <Typography.Subtitle3>Column Display Order</Typography.Subtitle3>
            <AuditColumnOrderingDraggable />
          </div>
        </div>
      </div>
    </div>
  );
}
